module.exports = [{"type":"hash","text":"心跳信息"},{"type":"normal","text":"當用戶的Websocket客戶端連接到Bingx Websocket服務器後，服務器會定期（當前設為5秒）向其發送心跳字符串ping"},{"type":"code","text":"{\"ping\":\"2177c68e4d0e45679965f482929b59c2\",\"time\":\"2022-06-07T16:27:36.323+0800\"}"},{"type":"normal","text":"當用戶的Websocket客戶端接收到此心跳消息後，應返回字符串pong消息"},{"type":"code","text":"pong"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/websocket/introduce/04_heart_beat.json
// module id = nCmZ
// module chunks = 3